import styled from 'styled-components';

export const Box = styled.div`
  span {
    font-size: 0.8rem;
    font-style: italic;
  }
`;
